import React, { useState } from "react";
import axios from "axios";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { CheckCircle2, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentReferenceForm() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "",
    invoice_number: "", w_number: "",
    amount: "", note: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.w_number || !form.w_number.trim()) {
      setError("W-nummer is verplicht — zonder W-nummer kunnen we de betaling niet correct koppelen.");
      return;
    }
    setSubmitting(true);
    try {
      const payload = { ...form, amount: form.amount ? Number(form.amount) : null };
      await axios.post(`${BACKEND_URL}/api/payment-reference`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      setDone(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Verzenden mislukt. Controleer je gegevens.");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="bg-green-50 border-l-4 border-green-500 px-5 py-6" data-testid="payment-reference-success">
        <div className="flex items-start gap-3">
          <CheckCircle2 className="w-6 h-6 text-green-700 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-chivo font-bold text-lg text-green-900">Betaalreferentie ontvangen</h3>
            <p className="text-sm text-green-800 mt-1">
              U kunt nu de betaling afronden via de Stripe-knop hieronder. Wij koppelen
              uw betaling aan W-nummer <span className="font-mono">{form.w_number}</span>.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <form className="space-y-4 bg-white border border-gray-200 p-6" onSubmit={onSubmit} data-testid="payment-reference-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div><Label>Naam *</Label><Input data-testid="payref-input-name" required value={form.name} onChange={set("name")} className="rounded-xl" /></div>
        <div><Label>E-mailadres *</Label><Input data-testid="payref-input-email" required type="email" value={form.email} onChange={set("email")} className="rounded-xl" /></div>
        <div><Label>Telefoonnummer</Label><Input data-testid="payref-input-phone" value={form.phone} onChange={set("phone")} className="rounded-xl" /></div>
        <div><Label>Factuurnummer</Label><Input data-testid="payref-input-invoice" value={form.invoice_number} onChange={set("invoice_number")} placeholder="bijv. INV-2025-1234" className="rounded-xl" /></div>
        <div className="sm:col-span-2">
          <Label>Zendingnummer / W-nummer *</Label>
          <Input data-testid="payref-input-wnumber" required value={form.w_number} onChange={set("w_number")} placeholder="W-xxxxx" className="rounded-xl font-mono" />
          <p className="text-[11px] text-gray-500 mt-1">Verplicht zodat we uw betaling direct kunnen koppelen.</p>
        </div>
        <div><Label>Bedrag (EUR)</Label><Input data-testid="payref-input-amount" type="number" step="0.01" min="0" value={form.amount} onChange={set("amount")} placeholder="optioneel" className="rounded-xl" /></div>
        <div className="sm:col-span-2"><Label>Opmerking</Label><Textarea data-testid="payref-input-note" rows={3} value={form.note} onChange={set("note")} className="rounded-xl" /></div>
      </div>

      {error && (
        <div data-testid="payment-reference-error" className="bg-red-50 border-l-4 border-red-500 text-red-700 px-3 py-2 text-sm">{error}</div>
      )}

      <Button data-testid="payment-reference-submit" type="submit" disabled={submitting} className="bg-[#082c50] hover:bg-[#082c50] text-white rounded-xl font-chivo font-bold uppercase text-sm px-8 py-6">
        {submitting ? (<><Loader2 className="w-4 h-4 mr-2 animate-spin" />Verzenden...</>) : "Betaalreferentie versturen"}
      </Button>
    </form>
  );
}
